const invertedMessages = {
  'User Life-Cycle Management':
    'external.userManagement.title.userLifeCycleManagement',
};

export default invertedMessages;
